import React, { useContext } from 'react';
import { Box, forwardRef } from '@chakra-ui/react';
import { getActionFooterStyles } from './action-menu-footer.theme';
import { ActionMenuContext } from './action-menu-context';

export interface ActionMenuFooterProps {
  children?: React.ReactNode;
}

/**
 * The `ActionMenuFooter` is a component that is a direct child of the `ActionMenuContent`
 * component that will affix itself to the bottom of the `ActionMenu`. This
 * component is typically used for placing buttons within it.
 */
export const ActionMenuFooter = forwardRef<ActionMenuFooterProps, 'div'>(
  ({ children, ...rest }, ref) => {
    const { colorMode } = useContext(ActionMenuContext);
    return (
      <Box ref={ref} sx={getActionFooterStyles(colorMode)} {...rest}>
        {children}
      </Box>
    );
  }
);
